module.exports = __webpack_public_path__ + "static/media/link-to-icon--white.2b6895d9.svg";